import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getStatus } from 'src/app/components/profile/user-profile/view-profile/regular-user-profile/regular-user-profile-helper';
import { EntityStatus } from 'src/app/interfaces/views.interface';
import { UserBasic } from 'src/app/swagger-api';

@Component({
  selector: 'app-activities-navigate-profile',
  templateUrl: './activities-navigate-profile.component.html',
  styleUrls: ['./activities-navigate-profile.component.scss'],
})
export class ActivitiesNavigateProfileComponent {
  @Input({ required: true }) public user: UserBasic;
  @Input({ required: true }) public dataTestId: string;

  @Input({ required: false }) public isDialog = false;
  @Input({ required: false }) public needComma = false;
  @Input({ required: false }) public isActiveUser = false;

  @Output() public submit: EventEmitter<void> = new EventEmitter<void>();

  public onSubmit(): void {
    this.submit.emit();
  }

  public getStatus(user: UserBasic): EntityStatus {
    return getStatus(user);
  }
}
